export enum StyleConstants {
  WHITE_COLOR = "#ffffff",
  HEADER = "#6489a7",
  FOOTER = "rgba(100,137,167,0.25)",
  ACTIVE_SECTION = "#6489a7",
  SECTION_BORDER = "#465258",
  BLACK_COLOR = "#000000",
  SKILLS_BG = "#bcd1e3",
  EDUCATION_BG = "#bcd1e3",
  NAVIGATION_BG = "#cfe3f2",

  SPACE_BETWEEN_SECTIONS = 65,

  SIZE_ITEM_TITLE = 18,
}
